import sortUsers from './sortUsers'

function contains(func, userMatch, asArray, criteria) {
  let match = false
  if (asArray) {
    match = userMatch.reduce((acc, match) => {
      if (!acc && match) {
        acc = match.toLowerCase()[func](criteria)
      }
      return acc
    }, false)
  } else {
    match = userMatch[func](criteria)
  }
  return match
}

export default function(state) {
  let users = state.approvedUsers
  if (state.currentView === 'unapproved') {
    users = state.unapprovedUsers
  }

  sortUsers(users, state.fetchOptions)

  if (!state.criteria) {
    return users
  } else {
    let criteria = state.criteria.toLowerCase()
    let filteredUsers = users.reduce((acc, user) => {
      let match = false
      state.filters.forEach(filter => {
        if (!match && user[filter]) {
          let field = user[filter]
          let userMatch = null
          let asArray = false
          if (Array.isArray(user[filter])) {
            // companies
            asArray = true
            userMatch = field
          } else {
            userMatch = field.toLowerCase()
          }
          if (userMatch) {
            match = contains(state.option, userMatch, asArray, criteria)
          }
        }
      })
      if (match) {
        acc.push(user)
      }
      return acc
    }, [])
    return filteredUsers
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/computed/filterUsers.js